export const usePrice = ({
  value,
  variant = 'regular',
  size = 'm',
  color = 'text-primary',
  fraction = false,
  units = '₽'
}) => {
  const localeOptions = {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2
  };
  const isValidValue = typeof value === 'number' && value >= 0;
  const stringValue = isValidValue ? value.toLocaleString('ru-RU', localeOptions).replace(/\s/g, '\u2009') : '—';
  const [integer, decimals] = stringValue.split(',');
  return {
    integer,
    decimals,
    units: units == null ? void 0 : units.replace(/\//g, '\u2009/\u2009'),
    showFraction: fraction && decimals,
    integerProps: {
      color,
      ...integerSizeMap[variant][size]
    },
    fractionProps: {
      color,
      ...fractionSizeMap[variant][size]
    }
  };
};
const integerSizeMap = {
  regular: {
    xs: {
      variant: 'caption'
    },
    s: {
      variant: 's',
      size: 'body_short'
    },
    m: {
      variant: 'm',
      size: 'body_long'
    },
    l: {
      variant: 'l',
      size: 'body_short'
    },
    xl: {
      variant: 'l',
      size: 'body_short'
    }
  },
  medium: {
    xs: {
      variant: 'caption_accent'
    },
    s: {
      variant: 's',
      size: 'body_accent'
    },
    m: {
      variant: 'm',
      size: 'body_accent'
    },
    l: {
      variant: 'l',
      size: 'subtitle'
    },
    xl: {
      variant: 'h2'
    }
  }
};
const fractionSizeMap = {
  regular: {
    xs: {
      variant: 'caption'
    },
    s: {
      variant: 'caption'
    },
    m: {
      variant: 'caption'
    },
    l: {
      variant: 's',
      size: 'body_long'
    },
    xl: {
      variant: 's',
      size: 'body_long'
    }
  },
  medium: {
    xs: {
      variant: 'caption_accent'
    },
    s: {
      variant: 'caption_accent'
    },
    m: {
      variant: 'caption_accent'
    },
    l: {
      variant: 's',
      size: 'body_accent'
    },
    xl: {
      variant: 'm',
      size: 'body_accent'
    }
  }
};